// @flow

import { connect } from 'react-redux';
import { fetchHealthGuide, removeHealthGuide } from '../actions/guide';
import Guide from './guide';

const mapStateToProps = ({ healthGuide, translations }) => ({
  healthGuide,
  translations,
});

export default connect(
  mapStateToProps,
  {
    fetchHealthGuide,
    removeHealthGuide,
  },
)(Guide);
